import React, { memo } from "react";
import { Button } from "react-bootstrap";
import UiDotLoader from "../common/UiDotLoader";

export const UiButton = memo((props) => {
    return (
        <>
            <Button
                className={props.className}
                onClick={props.onClick}
                {...props}
            >
                {props.imageIcon && (
                    <div>
                        <img src={props.imageIcon} />
                    </div>
                )}

                {props.svgIcon && props.svgIcon}

                {props.title}
            </Button>
        </>
    );
});

export const UiButtonPrimary = (props) => {
    return (
        <Button
            className={`${
                props.size
                    ? " sb-primary-btn--" + props.size
                    : "sb-primary-btn--48"
            } ${props.className}`}
            onClick={props.onClick}
            disabled={props.disabled}
            variant={props.variant}
        >
            {props.btnName}
            {props.subName && <span>{props.subName} </span>}
        </Button>
    );
};

export const UiButtonSecondary = (props) => {
    return (
        <>
            <Button
                disabled={props.disabled}
                className={
                    props.size
                        ? "sb-btn btn-secondary sb-secondary-btn--" + props.size
                        : "sb-btn btn-secondary sb-secondary-btn--70"
                }
                onClick={props.onClick}
            >
                {props.btnName}
                {props.subName && <span>{props.subName} </span>}
            </Button>
        </>
    );
};

export const UiButtonIcon = (props) => {
    return (
        <>
            <Button
                className={
                    props.size
                        ? "sb-btn-icon sb-btn-icon--" + props.size
                        : "sb-btn-icon sb-btn-icon--46"
                }
                onClick={props.onClick}
            >
                {props.icon}
                {props.btnName}
            </Button>
        </>
    );
};

export const UiButtonOutline = (props) => {
    return (
        <>
            <Button
                variant="outline-primary"
                className={
                    props.size
                        ? "sb-btn-outline sb-btn-outline--" + props.size
                        : "sb-btn-outline sb-btn-outline--46"
                }
                disabled={props.isLoading}
                onClick={!props.isLoading ? props.onClick : null}
            >
                {props.isLoading && <UiDotLoader />}

                {props.btnName}
            </Button>
        </>
    );
};
